class PaginationAjax extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      paginateButton: '[load-more-pagination]',
      listItem: '[product-list-items]',
      list: '[product-list]',
      productsCount: '[pagination-products-count]'
    };
    this.totalNumOfPages = 0;
    this.currentPageIndex = 0;
    this.fetchProductUrl = null;
    this.observer = null;
    this.init();
  }

  init() {
    this.paginateButton = this.querySelector(this.selectors.paginateButton);
    if (this.paginateButton) {
      this.paginateButton.addEventListener('click', () => {
        this.toggleLoading();
        this.loadMore();
      });
      // this.observer = new IntersectionObserver((entries) => {
      //   entries.forEach(entry => {
      //     if (entry.isIntersecting) {
      //       console.log("Hello World");
      //       this.loadMore();
      //     }
      //   });
      // });

      // this.observer.observe(this.paginateButton);
    }
    this.updateCurrentItems();
  }

  async loadMore() {
    this.totalNumOfPages = parseInt(this.paginateButton.getAttribute('data-size'));
    this.currentPageIndex = parseInt(this.paginateButton.getAttribute('data-current'));

    if (this.currentPageIndex < this.totalNumOfPages) {
      try {
        if (!this.fetchProductUrl) {
          this.fetchProductUrl = this.paginateButton.getAttribute('data-url');
        }
        if (this.fetchProductUrl) {
          console.log(this.fetchProductUrl);
          const response = await fetch(this.fetchProductUrl);
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          const data = await response.text();
          const htmlDocument = new DOMParser().parseFromString(data, 'text/html');
          this.updateDom(htmlDocument);
          this.currentPageIndex++;

          // Update the current page index attribute
          this.paginateButton.setAttribute('data-current', this.currentPageIndex);

          if (this.currentPageIndex >= this.totalNumOfPages) {
            this.handleLastPage();
          }
        }
      } catch (error) {
        console.error('Fetch error:', error);
      }
    } else {
      this.handleLastPage(); // Safeguard in case the button is still active
    }
  }

  updateDom(doc) {
    console.log(doc);
    const paginateButton = doc.querySelector(this.selectors.paginateButton);
    this.collectionProd = doc.querySelectorAll(this.selectors.listItem);
    const paginationEleSource = doc.querySelector('pagination-ajax');
    this.collectionProdList = document.querySelector(this.selectors.list);
    console.log(this.collectionProdList, this.collectionProd);
    
    this.collectionProd?.forEach((element) => {
      if (element) {
        this.collectionProdList.appendChild(element.cloneNode(true));
      }
    });
    if (paginateButton) {
      this.fetchProductUrl = paginateButton.getAttribute('data-url');
    } else {
      this.fetchProductUrl = null;
    }
    
    this.outerHTML = paginationEleSource.outerHTML;
    // this.toggleLoading();
  }

  handleLastPage() {
    // Remove the observer
    if (this.observer) {
      this.observer.disconnect();
    }

    // Disable the button and remove it from the DOM
    this.paginateButton.setAttribute('disabled', true);
    this.paginateButton.style.display = 'none';
  }
  toggleLoading() {
    this.paginateButton.classList.toggle('is-loading');
  }
  updateCurrentItems(){
    const collectionProd = document.querySelectorAll(this.selectors.listItem);
    const productsCount = this.querySelector(this.selectors.productsCount);
    if (productsCount && collectionProd) 
    productsCount.textContent = collectionProd.length;
  }
}

customElements.define('pagination-ajax', PaginationAjax);
